import React,{useState, useEffect} from "react";

function Header(props) {
  const [checked, setChecked] = useState(false);

  useEffect(()=>{
   props?.checkList?.length !== 0 ? setChecked(true) : setChecked(false);
  },[props?.checkList?.length]);

  return (
    <div className="table_inner_header">
      <ul className="table_container">
        <li className={`table_header ${props.semiChecked ? "semiactive" : ""}`}>
          <div className="col">
            <div className="check_wrap">
              <div className="check big">
                <input
                  type="checkbox"
                  className="input_checkbox"
                  id="checkall_bkplan"
                  onChange={() => props.headerCheckBox()}
                  checked={checked}
                />
                <label htmlFor="checkall_bkplan" />
              </div>
            </div>
          </div>
          <div
            className="col col1"
            onClick={() => props.toggleSort("planName")}
          >
            <div className="wrap_header_sort">
              <span
                className={`icon_sort file_sort_${
                  props.sortCol.col === "planName"
                    ? props.sortCol.order
                      ? "down"
                      : "up"
                    : "empty"
                }`}
              />
              <span className="header_title">Name</span>
            </div>
          </div>
          <div className="col col2">
            {/* <span className="icon_sort file_sort_empty" /> */}
            <span className="header_title">What to backup</span>
          </div>
          <div
            className="col col3"
            onClick={() => props.toggleSort("devicesLength")}
          >
            <div className="wrap_header_sort">
              <span
                className={`icon_sort file_sort_${
                  props.sortCol.col === "devicesLength"
                    ? props.sortCol.order
                      ? "down"
                      : "up"
                    : "empty"
                }`}
              />
              <span className="header_title">Devices</span>
            </div>
          </div>
          <div className="col col4">
            {/* <span className="icon_sort file_sort_empty" /> */}
            <span className="header_title">Schedule</span>
          </div>
          {/* <div className="col col5">
            <div className="wrap_header_sort">
              <span className="icon_sort file_sort_empty" />
              <span className="header_title">Where to backup</span>
            </div>
          </div> */}
        </li>
      </ul>
    </div>
  );
}

export default Header;
